import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Layout/Navigation';
import ScrollToTop from './components/Common/ScrollToTop';
import SplitScreenButton from './components/Common/SplitScreenButton';
import StartPage from './components/Pages/StartPage';
import TestPage from './components/Pages/TestPage';
import CreateAgentPage from './components/Pages/CreateAgentPage';
import CreateOrchestrationAgentPage from './components/Pages/CreateOrchestrationAgentPage';
import AccessibilityAgentPage from './components/Pages/AccessibilityAgentPage';
import ITHelpdeskAgentPage from './components/Pages/ITHelpdeskAgentPage';
import WorkdayAssistantPage from './components/Pages/WorkdayAssistantPage';
import RecruitingWorkforcePage from './components/Pages/RecruitingWorkforcePage';
import ExploreMarketplacePage from './components/Pages/ExploreMarketplacePage';
import ManageVtaPage from './components/Pages/ManageVtaPage';
import VtaAnalyticsPage from './components/Pages/VtaAnalyticsPage';
import SecurityAndDataProtectionPage from './components/Pages/SecurityAndDataProtectionPage';
import EducausePage from './components/Pages/EducausePage';
import './App.css';

const App = () => {
  return (
    <div className="min-h-screen bg-purple-50">
      <ScrollToTop />
      <Navigation />

      {/* Global Split Screen Button - Available on all pages */}
      <SplitScreenButton text="Open Split Screen" />

      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/test" element={<TestPage />} />
        <Route path="/manage-vta" element={<ManageVtaPage />} />
        <Route path="/vta-analytics" element={<VtaAnalyticsPage />} />
        <Route path="/create-agent" element={<CreateAgentPage />} />
        <Route path="/create-orchestration-agent" element={<CreateOrchestrationAgentPage />} />
        <Route path="/accessibility-agent" element={<AccessibilityAgentPage />} />
        <Route path="/it-helpdesk-agent" element={<ITHelpdeskAgentPage />} />
        <Route path="/workday-assistant" element={<WorkdayAssistantPage />} />
        <Route path="/recruiting-workforce" element={<RecruitingWorkforcePage />} />
        <Route path="/explore-marketplace" element={<ExploreMarketplacePage />} />
        <Route path="/security-and-data-protection" element={<SecurityAndDataProtectionPage />} />
        <Route path="/educause" element={<EducausePage />} />
      </Routes>
    </div>
  );
};

export default App;
